import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-based-log',
  templateUrl: './event-based-log.component.html',
  styleUrls: ['./event-based-log.component.scss']
})
export class EventBasedLogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
